import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Country } from '../models/country';
import { CountryInfoModel } from '../models/country-info-model';
import { State } from '../models/state';
import { LoadingDataService } from '../repositories/loading-data.service';
import { BrowserStorageService } from '../services/browser-storage.service';
import { BaseDataService } from './base-data.service';

@Injectable({
    providedIn: 'root'
})
@Injectable()

export class CountryService extends BaseDataService {
    private _countryList = new ReplaySubject<Array<Country>>();
    private countryList: Array<Country>;
    private _defaultCountry = '';
    private _defaultCountryCode = '';

    constructor(
        public httpClient: HttpClient,
        public loadingService: LoadingDataService,
        private storageService: BrowserStorageService) {
        super(httpClient, loadingService);

        this.refreshCountryList();
        this._countryList.subscribe(cl => {
            this.countryList = cl;
        });
    }


    public setCountryList(cl: Array<Country>) {
        this._countryList.next(cl);
    }

    public getCountryById(id: number) {
        return this.countryList.find(country => country.countryId === id);
    }
    public getIdByCountryName(name: string) {
        return this.countryList.find(country => country.countryName === name);
    }

    public getStatesByCountryCode(countryName: string, delegate: (states: Array<State>) => void): void {
        this.loadingService.loadingOtherData(true);
        this.get<any>('data/getstatesbycode?countryName=' + countryName, response => {
            this.loadingService.loadingOtherData(false);
            delegate(response);
        });
    }

    public getCountryList(): ReplaySubject<Array<Country>> {
        return this._countryList;
    }

    public getCountryCode(countryName: string): string {
        if (!this.countryList) { }

        return this.countryList.find(c => c.countryName === countryName).countryCode;
    }

    public getDefaultCountry(): string {
        return this._defaultCountry;
    }
    public getDefaultCountryCode(): string {
        return localStorage.getItem('countryCode');
    }


    public refreshCountryList(onFinish?: () => void) {
        return this.get<Array<Country>>('data/getcountrylist?code=' + this.storageService.getLocal('lang'), countries => {
            this.setCountryList(countries);
            if (onFinish) {
                onFinish();
            }
        });
    }

    public getCountryNameByIP() {
        if (localStorage.getItem('countryCode') == null) {
            return new Promise((resolve, reject) => {
                this.httpClient.get(this.getUrl('data/getbasecountryinfo')).subscribe((countryInfo: any) => {

                    this._defaultCountry = countryInfo.country_name;
                    this._defaultCountryCode = countryInfo.country_code;

                    localStorage.setItem('countryCode', this._defaultCountryCode);

                    resolve(true);
                }, error => {
                    resolve(true);
                });
            });
        }


        // this.get('data/getbasecountryinfo', countryInfo => {
        //     if (this.countryList && this.countryList.some(c => c.countryName === countryInfo['country'])) {
        //         this._defaultCountry = countryInfo['country_name'];
        //         this._defaultCountryCode = countryInfo['country_code'];
        //     } else {
        //         this._defaultCountry = '';
        //     }
        //     onComplete();
        // });
    }

    public getCountriesInfo(code: string, onComplete: (infos: Array<CountryInfoModel>) => void) {
        this.get<Array<CountryInfoModel>>('data/getcountriesinfo?code=' + code, onComplete);
    }
}
